<template>
    <validation-provider :rules="rules" :name="name" v-bind="$attrs" v-slot="{errors, valid, invalid, validated}">
        <b-form-group>
            <slot name="label">
                <label v-if="label" :class="labelClasses">
                    {{ label }}
                </label>
            </slot>
            <div :class="[
       {'input-group': hasIcon || loadingOptions || showOptionsLoadingAnimation},
       {'focused': focused},
       {'input-group-alternative': alternative},
       {'has-label': label || $slots.label},
       inputGroupClasses
       ]">
                <div v-if="prependIcon || $slots.prepend" class="input-group-prepend">
                    <slot name="prepend">
                        <span class="input-group-text">
                            <i :class="prependIcon"></i>
                        </span>
                    </slot>
                </div>

                <div v-if="loadingOptions || showOptionsLoadingAnimation" class="input-group-prepend">
                    <slot name="prepend">
                        <span class="input-group-text">
                            <loading-animation />
                        </span>
                    </slot>
                </div>

                <slot v-bind="slotData">
                    <input class="form-control" v-if="loadingOptions || showOptionsLoadingAnimation" value="Loading Options"/>
                    <vue-select
                        v-if="!loadingOptions && !showOptionsLoadingAnimation"
                        v-model="actualValue"
                        :disabled="disabled"
                        :options="actualOptions"
                        :valid="valid"
                        :required="required"
                        :multiple="multiple"
                        v-on="listeners"
                        class="form-control"
                        :class="[
                            {'is-valid': valid && validated && successMessage},
                            {'is-invalid': invalid && validated},
                            inputClasses
                        ]"></vue-select>
                </slot>

                <div v-if="appendIcon || $slots.append" class="input-group-append">
                    <slot name="append">
                        <span class="input-group-text">
                            <i :class="appendIcon"></i>
                        </span>
                    </slot>
                </div>
                <slot name="infoBlock"></slot>
            </div>
            <transition :name="animation" appear>
                <slot name="success">
                    <div class="valid-feedback" v-if="valid && validated && successMessage">
                        {{ successMessage }}
                    </div>
                </slot>
                <slot name="error" :errors="errors">
                    <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
                        {{ errors[0] }}
                    </div>
                </slot>
            </transition>
        </b-form-group>
    </validation-provider>
</template>
<script>
import vSelect from 'vue-select';
import axios from 'secure-axios';
import ValidatedFieldMixin from './ValidatedFieldMixin';

export default {
    inheritAttrs: false,
    name: 'validated-vue-select',
    components: { 'vue-select': vSelect },
    mixins: [ValidatedFieldMixin],
    props: {
        multiple: {
            type: Boolean,
            description: 'Whether input is multiple or not'
        },
        optionsURL: {
            type: String,
            description: 'Input type',
            default: ''
        },
        options: {
            type: Array,
            description: '',
            default: function () {
                return [];
            }
        },
        showOptionsLoadingAnimation: {
            type: Boolean,
            default: false
        }
    },
    mounted () {
        this.actualOptions = this.options;
        this.actualValue = this.value;
        const that = this;
        const needOptions = this.optionsURL !== undefined && this.optionsURL !== null && this.optionsURL !== '';
        if (!needOptions) {
            this.findActualValue();
        } else {
            this.loadingOptions = true;
            axios.get(this.optionsURL).then(function (response) {
                that.optionsLoaded(response);
            }).catch(function () {
                that.optionsFailed();
            });
        }
    },
    data () {
        return {
            loadingOptions: false,
            actualOptions: [],
            actualValue: ''
        };
    },

    watch: {
        options () {
            this.actualOptions = this.options;
            this.findActualValue();
        },

        "value"(newValue) {
            this.actualValue = newValue;
            this.findActualValue();
        }
    },

    methods: {
        optionsLoaded (response) {
            this.actualOptions = response.data.data;
            this.findActualValue();
            this.loadingOptions = false;
        },
        optionsFailed () {
            this.loadingOptions = false;
        },

        findActualValue () {
            const options = this.actualOptions;
            if (!options) {
                return;
            }

            if (this.multiple) {
                this.findActualValueMultiple(options);
                return;
            }

            const selectedValue = this.value + '';
            const len = options.length;
            let i;
            let item;
            for (i = 0; i < len; i += 1) {
                item = options[i];
                const value = item.value + '';
                if (value === selectedValue) {
                    this.actualValue = item;
                    return;
                }
            }
        },

        findActualValueMultiple (options) {
            const selectedValue = this.value;
            if (Array.isArray(selectedValue) === false) {
                this.actualValue = [];
                return;
            }

            const optionsLength = options.length;
            const selectedValueLength = selectedValue.length;

            let i;
            let j;
            let currentOption;
            let currentOptionValue;
            let selectedItemValue;
            const actualValues = [];

            for (i = 0; i < optionsLength; i += 1) {
                currentOption = options[i];
                currentOptionValue = options[i].value + '';
                for (j = 0; j < selectedValueLength; j += 1) {
                    selectedItemValue = selectedValue[j];
                    if(selectedItemValue.value) {
                        selectedItemValue = selectedItemValue.value;
                    }
                    selectedItemValue = selectedItemValue + "";
                    if (currentOptionValue === selectedItemValue) {
                        actualValues.push(currentOption);
                        break;
                    }
                }
            }

            this.actualValue = actualValues;
        },

        updateValue () {
            if (this.multiple) {
                const actualValues = this.actualValue;
                const result = [];
                const len = actualValues.length;
                let i;
                for (i = 0; i < len; i += 1) {
                    result.push(actualValues[i].value);
                }
                this.$emit('input', result);
            } else {
                let value = this.actualValue;
                if (value) {
                    value = value.value;
                }
                this.$emit('input', value);
            }
        }

    }
};
</script>
